// Passage d'un document à un autre dans une même instance (voir `TokaMapInstance.loadDocument`) :
// ce que le document entrant affiche et la façon de le rejoindre. Pur (aucune dépendance à
// MapLibre/au DOM), testable directement — `loadDocument` n'en fait que l'application.

import type { LoadedView } from "../loaders/formats/shared";

/**
 * La vue que le document entrant affiche : ses propres réglages, et pour chaque réglage qu'il ne
 * porte pas, la valeur de construction (`documentless`) — JAMAIS celle du document sortant. Sans
 * ça, une carte qui n'a jamais enregistré son fond OSM (resté en clair par défaut) hériterait du fond
 * sombre de la carte d'où l'on vient.
 */
export function resolveIncomingView(documentless: LoadedView, incoming: LoadedView | undefined): LoadedView {
  const definedFields = Object.entries(incoming ?? {}).filter(([, value]) => value !== undefined);

  return { ...documentless, ...Object.fromEntries(definedFields) };
}
